import React from 'react';

import { Node } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphTeaser = ({ entity }) => {
  return (
    <Node
      id={entity.getIn(['field_content', 0, 'target_id'])}
      isActivePath
      entity={entity.getIn(['field_content', 0, 'entity'])}
      viewMode="teaser"
    />
  );
};

export default ParagraphTeaser;
